import React from 'react';
import AbsoluteFooter from '../../components/Footer/AbsoluteFooter';

function Home() {
    return (
        <div className="secondary-bg min-h-screen">
            {/* <div className="w-full fixed top-0 min-h-[40px] p-3">
                <div
                    className="w-full relative h-full flex justify-between items-center gap-5 p-3 px-[5%] rounded-lg bg-black/30 backdrop-blur-xl"
                // style={{
                //     background: "rgba(var(--primary-rgb), 0.8)"
                // }}
                >
                    <img src="/assets/images/logo/dodeal-properties-white.png" alt="DoDeal Properties" className="w-[70px]" />
                </div>
            </div> */}
            <div className="w-full h-[90vh] flex flex-col gap-5 items-center justify-between">
                <div></div>
                <img src="/assets/images/logo/dodeal-properties-white.png" alt="DoDeal Properties" className="w-[250px]" />
                <div></div>
                {/* <div className="text-4xl text-center text-white font-bold">
                    PROPERTIES
                </div> */}
                <AbsoluteFooter />
            </div>
        </div>
    );
}

export default Home;
